export const raceQueryKeys = {
  all: () => "race"
};
